<template>

  <div
    class="buymodal-block__header">

    <div
      class="header-item"
      v-for="(item, i) in headers" :key="i"
      :class="[item.active ? 'active' : '',item.position == 0 ? 'position0' : item.position == -1 ? 'position-1' : item.position == -2 ? 'position-2' : item.position == -3 ? 'position-3' : item.position == 1 ? 'position1' : item.position == 2 ? 'position2' : item.position == 3 ? 'position3' : '']">
      <span
        class="circle">
        {{ i+1 }}
      </span>
      <span
        class="name">
        {{ item.name }}
      </span>
    </div>

  </div>

</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
    },
  },
};
</script>

<style lang="css">
</style>
